import React, { Component } from "react";
import FooterBg from "../../../../resources/images/footer-bg-image.svg";
import styles from "./Footer.module.scss";
import Translation from "../../../localization/Translation";
import MuiButton from "@mui/material/Button";

class FooterGraphic extends Component {
  render() {
    return (
      <div
        className={styles["footer-graphic__container"]}
        style={{ backgroundImage: `url("${FooterBg}")`, height: "270px" }}
      >
        <span className={styles["footer-graphic__title"]}>
          <Translation>Get Started Now!</Translation>
        </span>
        <span className={styles["footer-graphic__subtitle"]}>
          <Translation>
            You can buy and sell bitcoin as soon as your information is verified!
          </Translation>
        </span>
      </div>
    );
  }
}

export default FooterGraphic;
